import React from 'react';
import { FooterProps } from '../../../types';

const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  return (
    <footer className={`footer ${className}`}>
      <div className="footer__container">
        <div className="footer__content">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src="/inferiumTitleNoOwl.png" alt="Inferium Reports" />
            </div>
            <p className="footer__description">
              Professional security reporting platform for modern organizations. 
              Real-time insights, automated workflows, and comprehensive analytics.
            </p>
          </div>

          <div className="footer__section">
            <h3 className="footer__section-title">Product</h3>
            <ul className="footer__links">
              <li><a href="/features" className="footer__link">Features</a></li>
              <li><a href="/contact" className="footer__link">Request Demo</a></li>
              <li><a href="/pricing" className="footer__link">Pricing</a></li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__section-title">Support</h3>
            <ul className="footer__links">
              <li><a href="/contact" className="footer__link">Contact Sales</a></li>
              <li><a href="https://login.inferiumreports.com" target="_blank" rel="noopener noreferrer" className="footer__link">Client Login</a></li>
              <li><a href="/contact" className="footer__link">Help Center</a></li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__section-title">Legal</h3>
            <ul className="footer__links">
              <li><a href="/privacy" className="footer__link">Privacy Policy</a></li>
              <li><a href="/terms" className="footer__link">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {new Date().getFullYear()} Inferium Reports. All rights reserved.
          </p>
          <div className="footer__social">
            <a href="/contact" className="footer__social-link" aria-label="Contact us">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
